<template>
  <div>
    <div class="bg-white shadow rounded sm:rounded-lg tracking-wide p-4 mt-6 sm:p-5 relative border border-gray-200" :class="data.errors.length > 0 ? 'border-red-500' : ''">
      <!-- Delete Evidence Block-->
      <a href="javascript:void(0);" title="Remove" @click="deleteEvidence()" class="absolute -top-2 -right-2 bg-white rounded-full">
        <svg class="h-5 w-5 text-red-600" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
        </svg>
      </a>

      <!-- Evidence Type -->
      <div class="">
        <label class="block text-sm font-medium text-gray-800 mb-1">Evidence Type</label>
        <select class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full text-sm border-gray-300 rounded-md" name="evidence-type" v-model="data.evidence_type_id" @change="evidenceTypeSelectHandler($event)">
          <option disabled value>Please Select</option>
          <option v-for="evidenceType of evidence.types" :key="evidenceType.id" :value="evidenceType.id">{{ evidenceType.name }}</option>
        </select>
      </div>

      <div class="mt-5 space-y-5" v-if="data.evidence_type_id">

        <!-- ############################################################ -->
        <!-- ### Cosmetic Issue ### -->
        <!-- ############################################################ -->
        <div v-if="data.evidence_type_id == 1">
          <!-- Description -->
          <div>
            <label class="block text-sm font-medium text-gray-800">Issue Description</label>

            <small class="text-gray-600">Max 50 Characters. To enter multiple issues eg. foundation, roof, click 'Add More Cosmetic/Damage Issue' to enter each issue separately</small>

            <input type="text" placeholder="Enter Description" class="rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full text-sm border-gray-300 placeholder-gray-400 mt-1" v-model="data.description" maxlength="50" />
          </div>

          <!-- Cost of Repair -->
          <div>
            <label class="block text-sm font-medium text-gray-800 mt-5">
              Cost of Repair
            </label>
            <small class="text-gray-600">Enter numbers only</small>
            <div class="flex rounded-md shadow-sm mt-1">
              <span class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 font-medium">$</span>
              <input type="number" class="flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-r-md text-sm border-gray-300" placeholder="Enter Amount" min="0" v-model="data.cost_of_repairs" />
            </div>
          </div>
        </div>

        <!-- ############################################################ -->
        <!-- ### Repair Issue ### -->
        <!-- ############################################################ -->
        <div v-if="data.evidence_type_id == 2">
          <!-- Description -->
          <div>
            <label class="block text-sm font-medium text-gray-800">Issue Description</label>

            <small class="text-gray-600">Max 50 Characters. To enter multiple issues eg. foundation, roof, click 'Add More Cosmetic/Damage Issue' to enter each issue separately</small>

            <input type="text" placeholder="Enter Description" class="rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full text-sm border-gray-300 placeholder-gray-400 mt-1" v-model="data.description" maxlength="50" />
          </div>

          <!-- Cost of Repair -->
          <div class="">
            <label class="block text-sm font-medium text-gray-800 mt-5">
              Cost of Repair
            </label>
            <small class="text-gray-600">Enter numbers only</small>
            <div class="flex rounded-md shadow-sm mt-1">
              <span class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 font-medium">$</span>
              <input type="number" class="flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-r-md text-sm border-gray-300" placeholder="Enter Amount" min="0" v-model="data.cost_of_repairs" />
            </div>
          </div>
        </div>

        <!-- ############################################################ -->
        <!-- ### Closing Disclosure/ Settlement Statement ### -->
        <!-- ############################################################ -->
        <div v-if="data.evidence_type_id == 3">
          <!-- Statement Date -->
          <div>
            <label class="block text-sm font-medium text-gray-800">Statement Date</label>
            <small class="text-gray-600">The appraisal district will not consider a settlement statement or appraisal dated prior to 1/1/{{ lastYear }} as valid evidence</small>
            <div class="flex rounded-md shadow-sm mt-1">
              <span class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 font-medium">
                <i class="fa fa-calendar text-xs"></i>
              </span>
              <datepicker :format="'MM/dd/yyyy'" placeholder="Select Date" v-model="data.appraisal_date" :disabledDates="disabledDates" :wrapper-class="'w-full'" :input-class="'flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-r-md text-sm border-gray-300'"></datepicker>
            </div>
          </div>

          <!-- Purchase Price -->
          <div>
            <label class="block text-sm font-medium text-gray-800 mt-5">
              Purchase Price
            </label>
            <small class="text-gray-600">Enter numbers only</small>
            <div class="flex rounded-md shadow-sm mt-1">
              <span class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 font-medium">$</span>
              <input type="number" class="flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-r-md text-sm border-gray-300" placeholder="Enter Amount" min="0" v-model="data.purchase_price" />
            </div>
          </div>

          <!--  Upload Statement -->
          <div class="">
            <label class="block text-sm font-medium text-gray-800 mb-1 mt-5">
              Upload Statement
            </label>

            <div class="custom-file">
              <div class="p-3 border-2 border-gray-300 border-dashed rounded-md">
                <div class="text-center space-y-1">
                  <svg class="mx-auto h-6 w-6 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                    <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <div class="text-base text-gray-600">
                    <label :for="`file_upload_${evidence.uid}`" class="relative cursor-pointer bg-white rounded-md font-medium" :class="(data.uploads && data.uploads.length > 0) ? 'text-gray-400 cursor-not-allowed' : 'text-indigo-600 hover:text-indigo-500'">
                      <span>Upload File</span>
                      <input type="file" ref="uploadStatementFileInput" :id="`file_upload_${evidence.uid}`" class="sr-only " accept=".pdf" :disabled="(data.uploads && data.uploads.length > 0)" @change="uploadStatementHandler($event)" />
                    </label>
                  </div>
                  <h4 class="text-sm font-medium text-gray-700">Must upload all pages of closing disclosure/settlement statement</h4>
                  <small class="text-gray-600">
                    <span>Maximum one pdf is allowed.</span>
                  </small>
                </div>
              </div>
            </div>

            <div class="px-2 py-1 text-sm text-gray-800 bg-gray-50 border mt-3 break-all" :key="index" v-for="(file, index) in data.uploads">
              <div class="flex items-start justify-between">
                <!-- File has not been uploaded yet -->
                <span v-if="!file.id"> {{ file.name + ' (' + getFileSize(file) + 'MB)'}} </span>
                <span v-else> {{ file.file_name }} </span>
                <span class="text-red-500 cursor-pointer ml-1" @click="removeUploadStatement()">
                  <i class="fa fa-times"></i>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!-- ############################################################ -->
        <!-- ### Appraisal ### -->
        <!-- ############################################################ -->
        <div v-if="data.evidence_type_id == 4">
          <!-- Appraisal Date -->
          <div>
            <label class="block text-sm font-medium text-gray-800">Appraisal Date</label>
            <small class="text-gray-600">The appraisal district will not consider a settlement statement or appraisal dated prior to 1/1/{{ lastYear }} as valid evidence</small>
            <div class="flex rounded-md shadow-sm mt-1">
              <span class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 font-medium">
                <i class="fa fa-calendar text-xs"></i>
              </span>
              <datepicker :format="'MM/dd/yyyy'" placeholder="Select Date" v-model="data.appraisal_date" :disabledDates="disabledDates" :wrapper-class="'w-full'" :input-class="'flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-r-md text-sm border-gray-300'"></datepicker>
            </div>
          </div>

          <!-- Appraised Value -->
          <div>
            <label class="block text-sm font-medium text-gray-800 mt-5">
              Appraised Value
            </label>
            <small class="text-gray-600">Enter numbers only</small>
            <div class="flex rounded-md shadow-sm mt-1">
              <span class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 font-medium">$</span>
              <input type="number" class="flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-r-md text-sm border-gray-300" placeholder="Enter Amount" min="0" v-model="data.appraised_value" />
            </div>
          </div>

          <!-- Upload Appraisal -->
          <div>
            <label class="block text-sm font-medium text-gray-800 mb-1 mt-5">
              Upload Appraisal
            </label>
            <div class="custom-file">
              <div class="p-3 border-2 border-gray-300 border-dashed rounded-md">
                <div class="text-center space-y-1">
                  <svg class="mx-auto h-6 w-6 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                    <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <div class="text-base text-gray-600">
                    <label :for="`file_upload_${evidence.uid}`" class="relative cursor-pointer bg-white rounded-md font-medium" :class="(data.uploads && data.uploads.length > 0) ? 'text-gray-400 cursor-not-allowed' : 'text-indigo-600 hover:text-indigo-500'">
                      <span> Upload File</span>
                      <input type="file" ref="uploadAppraisalFileInput" :id="`file_upload_${evidence.uid}`" class="sr-only " accept=".pdf" :disabled="(data.uploads && data.uploads.length > 0)" @change="uploadAppraisalHandler($event)" />
                    </label>
                  </div>
                  <h4 class="text-sm font-medium text-gray-700">Must upload all pages of the appraisal</h4>
                  <small class="text-gray-600">
                    <span>Maximum one pdf is allowed.</span>
                  </small>
                </div>
              </div>
            </div>

            <div class="px-2 py-1 text-sm text-gray-800 bg-gray-50 border mt-3 break-all" :key="index" v-for="(file, index) in data.uploads">
              <div class="flex items-start justify-between">
                <!-- File has not been uploaded yet -->
                <span v-if="!file.id"> {{ file.name + ' (' + getFileSize(file) + 'MB)'}} </span>
                <span v-else> {{ file.file_name }} </span>
                <span class="text-red-500 cursor-pointer ml-1" @click="removeAppraisalStatement()">
                  <i class="fa fa-times"></i>
                </span>
              </div>
            </div>
          </div>

        </div>

        <!-- ############################################################ -->
        <!-- ### Others Issue ### -->
        <!-- ############################################################ -->
        <div v-if="data.evidence_type_id == 5">
          <!-- Other Description -->
          <div>
            <label class="block text-sm font-medium text-gray-800" v-if="[5].includes(data.evidence_type_id)">
              Other Description
            </label>
            <small class="text-gray-600">Max 50 Characters. To enter multiple issues eg. foundation, roof, click 'Add More Cosmetic/Damage Issue' to enter each issue separately</small>

            <input type="text" placeholder="Enter Description" class="rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full text-sm border-gray-300 placeholder-gray-400 mt-1" v-model="data.description" maxlength="50" />
          </div>

          <!-- Cost/Value Impact -->
          <div>
            <label class="block text-sm font-medium text-gray-800 mt-5">
              Cost/Value Impact
            </label>
            <small class="text-gray-600">This is the amount we should subtract from the total market value</small>
            <div class="flex rounded-md shadow-sm mt-1">
              <span class="inline-flex items-center px-3 rounded-l-md border border-r-0 border-gray-300 bg-gray-50 text-gray-500 font-medium">$</span>
              <input type="number" class="flex-1 block w-full focus:ring-indigo-500 focus:border-indigo-500 min-w-0 rounded-none rounded-r-md text-sm border-gray-300" placeholder="Enter Amount" min="0" v-model="data.cost_or_value_impact" />
            </div>
          </div>
        </div>

        <!-- Upload Photos -->
        <div v-if="[1,2,5].includes(data.evidence_type_id)">
          <label class="block text-sm font-medium text-gray-800 mb-1 mt-5">
            Upload Photos 
          </label>
          <div class="gap-6 grid grid-cols-1 md:grid-cols-2">
            <div v-for="upload in data.uploads">
              <upload-photo :key="upload.uid" :upload="upload" v-on:upload-image="editImage" v-on:edit-image="editImage" v-on:delete-image="deletePhoto"></upload-photo>
            </div>
          </div>
           <!-- cropper -->
            <div v-if="showImageCropper">
              <image-cropper :uploadImgData="uploadImgData" :isImageEdited="isImageEdited" v-on:crop-image-data="cropImageData"></image-cropper>
            </div>
          <!-- cropper -->
        </div>

        <!-- Invoice Upload -->
        <div class="" v-if="[1,2,5].includes(data.evidence_type_id)">
          <label v-if="data.evidence_type_id == 5" class="block text-sm font-medium text-gray-800 mb-1">
            Upload File
          </label>

          <label v-else class="block text-sm font-medium text-gray-800 mb-1">
            Upload Estimate/Invoice
          </label>

          <div class="custom-file">
            <div class="p-3 border-2 border-gray-300 border-dashed rounded-md">
              <div class="text-center space-y-1">
                <svg class="mx-auto h-6 w-6 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                  <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <div class="text-base text-gray-600">
                  <label :for="`invoice_${evidence.uid}`" class="relative cursor-pointer bg-white rounded-md font-medium" :class="(data.invoice != null) ? 'text-gray-400 cursor-not-allowed' : 'text-indigo-600 hover:text-indigo-500'">
                    <span>Upload File</span>
                    <input type="file" ref="invoiceUploadInputFile" class="sr-only" accept="image/*, .pdf" :id="`invoice_${evidence.uid}`" :disabled="data.invoice != null" @change="InvoiceUploadHandler($event)" />
                  </label>
                </div>
                <small class="text-gray-600">
                  <span>Only 1 JPG, PNG or PDF is allowed.</span>
                </small>
              </div>
            </div>
          </div>

          <div class="px-2 py-1 text-sm text-gray-800 bg-gray-50 border mt-3 break-all" v-if="data.invoice">
            <div class="flex items-start justify-between">
              <span v-if="!data.invoice.id"> {{ data.invoice.name + ' (' + getFileSize(data.invoice) + 'MB)'}} </span>
              <span v-else> {{ data.invoice.file_name }}</span>
              <span class="text-red-500 cursor-pointer ml-1" @click="removeUploadedInvoice()">
                <i class="fa fa-times"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row text-danger" v-if="data.errors.length > 0">
      <ul class="text-sm text-red-500 mt-1">
        <li v-for="(error,index) in data.errors" :key="index">
          <i class="fa fa-exclamation-triangle"></i> {{ error }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { helpers } from "../../../../mixins/helpers.js";
import Datepicker from "vuejs-datepicker";
import ProtestRequestApi from "../../../../services/api/AdminProtestRequest.js";
import ImageCropper from "../Evidences/Modal/ImageCropper.vue";
import UploadPhoto from "../Evidences/UploadPhoto.vue";

export default {
  props: ["evidence"],

  mixins: [helpers],

  components: {
    Datepicker,
    ImageCropper,
    UploadPhoto,
  },

  data() {
    return {
      data: [],
      disabledDates: null,
      lastYear: null,
      uploadImgData:[],
      showImageCropper:false,
      cropImg: "",
      isCropeedImageSelect:false,
      isImageEdited:false,
    };
  },

  created() {
    this.lastYear = last_year;

    this.disabledDates = {
      to: new Date(this.lastYear, 0, 1),
      from: new Date(),
    };


    let initialValues = {
      evidence_type_id: "",
      description: null,
      appraisal_date: null,
      appraised_value: null,
      purchase_price: null,
      cost_or_value_impact: null,
      cost_of_repairs: null,
      uploads: [],
      invoice: null,
      errors: [],
    };

    let mapSavedValues = {
      uploads: this.evidence.uploads
        ? this.evidence.uploads.filter((upload) => !upload.is_invoice)
        : [],
      invoice: this.evidence.uploads
        ? this.evidence.uploads.find((upload) => upload.is_invoice)
        : null,
    };

    this.data = { ...initialValues, ...this.evidence, ...mapSavedValues };
    
    this.addImagesSection();
  },

  methods: {
    addImagesSection(){
      // console.log(this.data);
      if([1,2,5].includes(this.data.evidence_type_id) && this.data.uploads){
        for (let index = this.data.uploads.length; index < 5; index++) {
          this.data.uploads.push({'img_src':'','uid':''});
        }
      }
    },
    deleteEvidence() {
      // Evidence is not stored in DB yet.
      if (!this.data.id) {
        this.$emit("delete-evidence", this.data);
        return;
      }

      // Evidence has stored in DB.
      if (confirm("Do you want to delete evidence?")) {
        ProtestRequestApi.deleteEvidence(
          this.data.protest_request_uid,
          this.data.uid
        ).then((res) => {
          if (res && !res.error) {
            window.location.reload();
          } else {
            alert(res.error);
          }
        });
      }
    },

    evidenceTypeSelectHandler(event) {
      if([1,2,5].includes(this.data.evidence_type_id)){
        this.data.uploads = [];
        for (let index = 0; index < 5; index++) {
          this.data.uploads.push({'img_src':'','uid':''});
        }
      }
    },

    getFileSize(file) {
      return Number((file.size / 1024 / 1024).toFixed(1));
    },

    //###################################################################################################
    // ## Statement ##
    //###################################################################################################
    uploadStatementHandler() {
      let files = this.$refs.uploadStatementFileInput.files;
      this.data.uploads.push(files[0]);
    },

    removeUploadStatement() {
      this.data.uploads = [];
    },

    //###################################################################################################
    // ## Appraisal ##
    //###################################################################################################

    uploadAppraisalHandler() {
      let files = this.$refs.uploadAppraisalFileInput.files;
      this.data.uploads.push(files[0]);
    },

    removeAppraisalStatement() {
      this.data.uploads = [];
    },


    // edit image for crop
    editImage(data){
      var self = this;  
      self.isImageEdited = data.isImageEdited;
      self.uploadImgData.img_src = data.img.img_src;
      self.uploadImgData.file_name = data.img.file_name;
      self.uploadImgData.uid = data.img.uid;
      self.showImageCropper = data.show_image_cropper;
    },

    deletePhoto(data){
      for(let upload of Object.values(this.data.uploads)) {
        if(upload.uid && upload.uid == data.img.uid ){
          if(upload.file_path != ''){
            for(let key of Object.keys(upload)){
              if(!(key == 'uid' || key=='file_name' || key == 'img_src')){
                delete upload[key];
              }
            }
          }
          upload.img_src = "";
          upload.uid = "";
          upload.file_name = "";
        }
      }
    },

    cropImageData(data){
      var self = this;
      self.imgSrc = '';
      self.showImageCropper = false;
      for(let upload of Object.values(this.data.uploads)) {
        if(upload.uid && upload.uid == data.uid ){
          if(upload.file_path != ''){
            for(let key of Object.keys(upload)){
              upload.uid = Math.random().toString(16).slice(2);
              if(!(key == 'uid' || key=='file_name' || key == 'img_src')){
                delete upload[key];
              }
            }
          }
          upload.img_src = data.crop_img
        }
      }
    },

    // photoUploadHandler() {
    //   let files = this.$refs.photoUploadFileInput.files;

    //   for (var i = files.length - 1; i >= 0; i--) {
    //     this.data.uploads.push(files[i]);
    //   }
    // },

    // removePhotoUploadFile(file) {
    //   this.data.uploads.splice(this.data.uploads.indexOf(file), 1);
    // },

    InvoiceUploadHandler() {
      this.data.invoice = this.$refs.invoiceUploadInputFile.files[0];
    },

    removeUploadedInvoice() {
      this.data.invoice = null;
    },
  },
  watch: {
    data: {
      deep: true,
      handler: function (val, oldVal) {
        this.$emit("update-evidences", this.data);
        // console.log(this.data);
        if(this.data.errors && this.data.errors.length > 0){
          this.addImagesSection();
        }
      },
    },
  },
};
</script>
